import type {ProjectId} from '../../../../types'
import {stringifyId} from '../../../../types'

export const getCountTestProjectInvestigationsLocator = (projectId: ProjectId) =>
  `affectedProject:${stringifyId(
    projectId,
  )},currentlyFailing:true,currentlyInvestigated:true,count:1001`
